import { render, staticRenderFns } from "./DSpinner.vue?vue&type=template&id=a0b5521a&scoped=true"
import script from "./DSpinner.vue?vue&type=script&lang=js"
export * from "./DSpinner.vue?vue&type=script&lang=js"
import style0 from "./DSpinner.vue?vue&type=style&index=0&id=a0b5521a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b5521a",
  null
  
)

export default component.exports